/**
 * current melonJS version
 */
export const version = __VERSION__;
